export default {"src":"/_next/static/media/logo.5555f699.svg","height":44,"width":59,"blurWidth":0,"blurHeight":0};